const TOKEN_KEY = 'jizhu_token';
const USER_KEY = 'jizhu_user';
const AUTH_EVENT = 'jizhu-auth-changed';

function notify() {
  window.dispatchEvent(new Event(AUTH_EVENT));
}

export function getToken(): string | null { return localStorage.getItem(TOKEN_KEY); }
export function setToken(t: string) { localStorage.setItem(TOKEN_KEY, t); notify(); }
export function clearToken() { localStorage.removeItem(TOKEN_KEY); notify(); }

export function getUser(): { id: string; email: string } | null {
  const v = localStorage.getItem(USER_KEY);
  return v ? JSON.parse(v) : null;
}
export function setUser(u: { id: string; email: string }) { localStorage.setItem(USER_KEY, JSON.stringify(u)); notify(); }
export function clearUser() { localStorage.removeItem(USER_KEY); notify(); }

export function isLoggedIn(): boolean { return !!getToken(); }
export function onAuthChange(handler: () => void): () => void {
  window.addEventListener(AUTH_EVENT, handler);
  return () => window.removeEventListener(AUTH_EVENT, handler);
}

export function logout() { clearToken(); clearUser(); }
